<template>
  <div class="coinstream">
    <XR-head titleText="WUA交易记录" :rightShow="false"></XR-head>
    <div class="gd-content">
      <div class="gd-content-tab-dd" id="list" v-if="!loaded">    
        <dl v-for="wuaItem in wuaList" :key="wuaItem.TraceNo">
          <router-link :to="'/usercenter/wuaDetail?traceNo=' + wuaItem.TraceNo">
            <dd>
              <table>
                <tbody>
                  <tr>
                    <td class="first-row" rowspan="2"><img :src="getIconByTraceType(wuaItem.TraceType)"></td>
                    <td :class="wuaItem.Operater=='+'?'secend-row calcPluas':'secend-row calcMinus'"><i>{{wuaItem.ToAddress}}</i>{{wuaItem.Operater+wuaItem.TraceAmt}}</td>
                  </tr>
                  <tr>
                    <td class="one-row ">{{wuaItem.AddTimeName}}</td>
                  </tr>
                </tbody>
              </table>
            </dd>
          </router-link>
        </dl>   
      </div>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loaded: true,
      wuaList:{}
    };
  },
  mounted:function(){
    this.$refs.XRtoast.load()
    this.getWuaStreamPage()
  },
  methods: {
    getIconByTraceType:function(traceType){
      if(traceType == 3 || traceType == 2){
        return '/static/icon/pay.png'
      }
      else if(traceType == 5|| traceType == 1|| traceType ==4 ){
        return '/static/icon/refund.png'
      }
    },
    getWuaStreamPage: function() {
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetWuaStreamPage"
      ).then(function(res) {
        if(!res.IsSuccess){
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{          
          ths.wuaList = res.Data.List;
          ths.loaded = false
          ths.$refs.XRtoast.hide()
        }
      });
    }
  }
};
</script>
<style>
*{
  margin: 0;
  padding: 0;
}
.coinstream .gd-content{
  background: white;
  overflow: hidden;
}
    .coinstream .gd-content table {
        width:96%;
    }
    .coinstream .gd-content table td {
        vertical-align:middle;
    }
        .coinstream .gd-content table td.first-row {
            padding-top:5px;
            width:48px;
            line-height:16px;
            text-align: center;
        }
           .coinstream  .gd-content table td.first-row img {
                width:28px;                
            }

       .coinstream  .gd-content table td.secend-row {
            padding-top:17px;
            line-height:14px;
            text-align:right;
            font-style:normal;
        }
       .coinstream  .gd-content table td.secend-row i{
            float:left;
            color:#8F94A1;
        }
        .coinstream .gd-content table td.one-row {
            padding-bottom:17px;
            border-bottom:1px solid #F6F6F6;
            line-height:14px;
            color:#CDCDCD;
            font-size:12px;
        }
           .coinstream  .gd-content table td.one-row.last {
                border:none;
            }

.coinstream .calcPlus {
    color:red;
}
.coinstream .calcMinus {
    color:#59C2A4;
}

.coinstream .coin-info {
    padding:5px 0 20px;
    text-align:center;
}
    .coinstream .coin-info .balance {
        font-size:24px;
    }
    .coinstream .coin-info .balance-title {
        font-size:12px;
        color:#999;
        padding-top:4px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/wuaStream.vue